import { RootState, Cursor } from 'js/types';

export default function getAllCursors(state: RootState): Array<Cursor> {
  return Object.values(state.cursors).flat();
}
